import React from 'react'
// @ts-ignore
import { OpenInNewTab } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import SourceType, { SourceTypeStrings } from 'enums/SourceType'
import Domain from 'enums/Domain'
import i18n from 'i18n'
import ActionIconsContainer from './ActionIconsContainer'

const getMessage = (source: SourceTypeStrings, domain: string) => {
  switch (source) {
    case SourceType.TWITTER:
    case SourceType.FACEBOOK:
    case SourceType.INSTAGRAM:
    case SourceType.YOUTUBE:
    case SourceType.SUBREDDITS:
      return i18n.t('viewOn', { source })
    default:
  }

  switch (domain) {
    case Domain.WEIBO:
      return i18n.t('viewOn', { source: 'Weibo' })
    case Domain.TIKTOK:
      return i18n.t('viewOn', { source: 'TikTok' })
    case Domain.REDDIT:
      return i18n.t('viewOn', { source: 'Reddit' })
    case Domain.BLUESKY:
      return i18n.t('viewOn', { source: 'Bluesky' })
    default:
      return i18n.t('viewOn', { source: i18n.t('theWebsite') })
  }
}

const ViewOnIcon = ({
  source,
  domain,
  url,
  displayText = true,
  iconColor
}: {
  source: SourceTypeStrings
  domain: string
  url?: string
  displayText?: boolean
  iconColor?: string
}) => {
  const theme = useDisplayTheme() as Theme
  const color = iconColor || sys[theme].text.placeholder
  const message = displayText ? getMessage(source, domain) : ''

  return (
    <ActionIconsContainer message={message} url={url} tooltipContent={getMessage(source, domain)}>
      <OpenInNewTab color={color} />
    </ActionIconsContainer>
  )
}

export default ViewOnIcon
